(function() { module.exports = this["vendor"]; }());


//////////////////
// WEBPACK FOOTER
// external "vendor"
// module id = 3
// module chunks = 0